import { render, staticRenderFns } from "./UploadClosed.vue?vue&type=template&id=0c5c5063&scoped=true"
import script from "./UploadClosed.vue?vue&type=script&lang=js"
export * from "./UploadClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c5063",
  null
  
)

export default component.exports